export const translations = {
  es: {
    // Navigation
    nav: {
      home: 'Inicio',
      about: 'Sobre Mí',
      projects: 'Proyectos',
      pricing: 'Precios',
      skills: 'Habilidades',
      contact: 'Contacto',
      language: 'Idioma'
    },
    // Hero Section
    hero: {
      welcome: '👋 Bienvenido a mi portafolio',
      title: 'Editor de Video',
      subtitle: 'Creo historias visuales impactantes y contenido profesional. Especializado en edición de video, composición y narrativas creativas.',
      viewProjects: 'Ver Proyectos'
    },
    // About Section
    about: {
      title: 'Sobre Mí',
      content: 'Soy Danel (o Danez), un creador de contenido y editor de video con más de 4 años de experiencia en el medio. Me concentro tanto en edición para streamers/creadores de contenido, como para enfoques profesionales o cinematográficos.',
      additionalContent: 'Mi fuerte es la edición de clips de streaming para formato vertical "short" y videos guionizados, además de conocimiento en motion graphics, corrección de color y efectos visuales.',
      emailCopied: '¡Copiado!',
      emailLabel: 'danez4344@gmail.com',
      discordLabel: 'Discord: Danez43'
    },
    // Projects Section
    projects: {
      title: 'Mis Videos',
      subtitle: '',
      professionalProjects: 'Proyectos Profesionales',
      socialProjects: 'Proyectos Redes',
      irlProjects: 'Proyectos IRL (In Real Life)',
      viewVideo: 'Ver Video',
      close: 'Cerrar'
    },
    // Skills Section
    skills: {
      title: 'Habilidades',
      subtitle: 'Herramientas y tecnologías que domino para crear contenido excepcional',
      categories: {
        editingTools: {
          title: 'Herramientas de Edición',
          icon: '🎬',
          items: ['Cap Cut', 'After Effects','Adobe Premiere Pro','Photoshop']
        },
        specialties: {
          title: 'Especialidades',
          icon: '✨',
          items: ['Color Grading', 'Motion Graphics', 'Post-producción', 'Edición narrativa']
        },
        certifications: {
          title: 'Certificaciones',
          icon: '🏆',
          items: ['Tecnico en diseño de imagen, sonido y multimedia (UNNE)']
        }
      }
    },
    // Contact Section
    contact: {
      title: 'Contacto',
      subtitle: '¿Tienes un proyecto en mente? ¡Hablemos!'
    },
    // Pricing Section
    pricing: {
      title: 'Precios',
      shorts: {
        title: 'Shorts Verticales',
        features: [
          'Precio por video individual',
          'Varía según duración y complejidad'
        ]
      },
      professional: {
        title: 'Proyectos Profesionales',
        custom: 'Personalizado',
        features: [
          'Presupuesto a convenir según alcance',
          'Debe ser charlado previamente'
        ]
      },
      longVideos: {
        title: 'Videos Largos (YouTube)',
        consult: 'Consultar',
        features: [
          'Precio según duración y nivel de edición'
        ]
      }
    },
    // Footer
    footer: {
      copyright: '© 2024 Danel. Hecho con React y Tailwind CSS'
    },
    // Common
    common: {
      loading: 'Cargando...',
      error: 'Error',
      close: 'Cerrar'
    }
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      projects: 'Projects',
      pricing: 'Pricing',
      skills: 'Skills',
      contact: 'Contact',
      language: 'Language'
    },
    // Hero Section
    hero: {
      welcome: '👋 Welcome to my portfolio',
      title: 'Video Editor',
      subtitle: 'I create impactful visual stories and professional content. Specialized in video editing, composition, and creative narratives.',
      viewProjects: 'View Projects'
    },
    // About Section
    about: {
      title: 'About Me',
      content: 'I am Danel (or Danez), a content creator and video editor with over 4 years of experience in the field. I focus on editing for streamers/content creators, as well as professional or cinematographic approaches.',
      additionalContent: 'My strength is editing streaming clips for vertical "short" format and scripted videos, plus knowledge in motion graphics, color correction, and visual effects.',
      emailCopied: 'Copied!',
      emailLabel: 'danez4344@gmail.com',
      discordLabel: 'Discord: Danez43'
    },
    // Projects Section
    projects: {
      title: 'My Videos',
      subtitle: '',
      professionalProjects: 'Professional Projects',
      socialProjects: 'Social Media Projects',
      irlProjects: 'IRL Projects (In Real Life)',
      viewVideo: 'View Video',
      close: 'Close'
    },
    // Skills Section
    skills: {
      title: 'Skills',
      subtitle: 'Tools and technologies I\'ve mastered to create exceptional content',
      categories: {
        editingTools: {
          title: 'Editing Tools',
          icon: '🎬',
          items: ['Cap Cut', 'After Effects', 'Adobe Premiere Pro', 'Photoshop']
        },
        specialties: {
          title: 'Specialties',
          icon: '✨',
          items: ['Color Grading', 'Motion Graphics', 'Post-production', 'Narrative Editing']
        },
        certifications: {
          title: 'Certifications',
          icon: '🏆',
          items: ['Technician in Image, Sound and Multimedia Design (UNNE)']
        }
      }
    },
    // Contact Section
    contact: {
      title: 'Contact',
      subtitle: 'Have a project in mind? Let\'s talk!'
    },
    // Pricing Section
    pricing: {
      title: 'Pricing',
      shorts: {
        title: 'Vertical Shorts',
        features: [
          'Price per individual video',
          'Varies based on duration and complexity'
        ]
      },
      professional: {
        title: 'Professional Projects',
        custom: 'Custom',
        features: [
          'Budget agreed based on scope',
          'Must be discussed beforehand'
        ]
      },
      longVideos: {
        title: 'Long Videos (YouTube)',
        consult: 'Consult',
        features: [
          'Price based on duration and editing level'
        ]
      }
    },
    // Footer
    footer: {
      copyright: '© 2025 Danel. Made with React and Tailwind CSS'
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      close: 'Close'
    }
  }
};
